module.exports = __webpack_public_path__ + "static/media/menu.d0661262.svg";